/** Created by azhou on 2019/2/18.*/
<template>
  <!--供应商(酒店完善基本信息)-->
  <div class="blank_space">
    <div class="check-item" v-for="(checkItem,index) in checkList" :key="index">
      <span :class="{'text-danger':!checkItem.checked}">{{checkItem.name}}</span>
      <i class="iconfont" :class="[checkItem.checked ? 'text-success':'text-danger']"
         v-html="checkItem.checked?successIcon:failIcon"></i>
    </div>
    <div class="text-center mt-3">
      <el-button @click="setVerifyStatue" class="mt-4 w-25 btn-login" :disabled="!allChecked || waitVerify">
        {{waitVerify?'认证审核中':'提交认证'}}
      </el-button>
      <p class="mt-4 text-danger" v-if="waitVerify">
        等待审核，请留意您的微信或短信消息
      </p>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'

  export default {
    name: 'RegSubmit',
    data () {
      return {
        successIcon: '&#xe74a;',
        failIcon: '&#xe7b7;',
      }
    },
    computed: {
      ...mapState(['StoreBasicInfo', 'StoreRoomArr', 'StoreMeetArr', 'newMessageInform','userLoginMessage']),
      ...mapGetters(['storeInfo','isGroup','isAdmin']),
      checkList () {
        let pic = this.StoreBasicInfo.pic ? this.StoreBasicInfo.pic.length : ''
        let interiorPic = this.StoreBasicInfo.pic_lobby ? this.StoreBasicInfo.pic_lobby.length : ''
        let pic_common = this.StoreBasicInfo.pic_common ? this.StoreBasicInfo.pic_common.length : ''
        let storeCn = this.$options.filters['formatVar'](this.storeInfo.type, 'StoreType')
        let commonArr = [
          { name: storeCn + '名称', checked: Boolean(this.StoreBasicInfo.title) },
          { name: storeCn + '地址', checked: Boolean(this.StoreBasicInfo.address) },
          { name: storeCn + '星级', checked: Boolean(this.StoreBasicInfo.star) },
          // { name: '办公电话', checked: Boolean(this.StoreBasicInfo.tel || this.StoreBasicInfo.viewpoint_tel) },
          {
            name: this.storeInfo.type === 3 ? '酒店总机' : '办公电话',
            checked: Boolean(this.StoreBasicInfo.tel || this.StoreBasicInfo.hotel_tel || this.StoreBasicInfo.homestay_tel|| this.StoreBasicInfo.travel_tel)
          },          
          // { name: '营业执照', checked: Boolean(this.StoreBasicInfo.certpic) },
          { name: '客房数量', checked: Boolean(this.StoreBasicInfo.room_count*1) },
          { name: '双床房数量', checked: Boolean(this.StoreBasicInfo.room_2_count*1) },
        ]
        if (this.storeInfo.type === 6) {
          return [
            ...commonArr,
            { name: '传真号码', checked: Boolean(this.StoreBasicInfo.viewpoint_fax) },
            { name: '景区主题', checked: Boolean(this.StoreBasicInfo.theme) },
            { name: '景区星级', checked: Boolean(this.StoreBasicInfo.star + '') },
            { name: storeCn + '外观图', checked: Boolean(pic) }
          ]
        }else {
          return commonArr
        // if (this.storeInfo.type === 3 || this.storeInfo.type === 5) {
        //   console.log(this.StoreRoomArr);
        //   return [
        //     ...commonArr,
        //     // {
        //     //   name: this.storeInfo.type === 3 ? '酒店总机' : '前台电话',
        //     //   checked: Boolean(this.StoreBasicInfo.hotel_tel || this.StoreBasicInfo.homestay_tel)
        //     // },
        //     { name: storeCn + '外观图', checked: Boolean(pic) },
        //     { name: storeCn + '大堂图', checked: Boolean(interiorPic) },
        //     { name: storeCn + '公共图', checked: Boolean(pic_common) },
        //     { name: storeCn + '房型', checked: Boolean(this.StoreRoomArr.meetArr.length) },

        //   ]
        // } 
        }
      },
      allChecked () {
        let result = true
        for (let i = 0; i < this.checkList.length; i++) {
          if (!this.checkList[i].checked) {
            result = false
            return false
          }
        }
        return result
      },
      waitVerify () {
        return this.storeInfo.verify === 2
      }
    },
    watch: {
      //满足所有认证提交提醒提交认证操作
      allChecked (newVal) {
        if (newVal && this.storeInfo.verify === 0) this.setVerifyStatue()
      },
      //认证通过进行页面跳转
      newMessageInform (newVal) {
        if (newVal && newVal.type === 3) {
          // this.updateInfo()
          // if (newVal.verify == '1') {      //认证通过
          //   //管理员和集团账号时重新拉取门店信息
          //   console.log(newVal,this.isGroup);
          //   if (this.isGroup) this._alert('门店已认证通过！',() => { this.$router.push({name:'StoreBasicInfo'}); })
          //   else this.$router.push('/userCenter')          //单门店身份自动跳转到会员中心
          // } else this._alert('很遗憾，您的认证未通过，如有疑问请联系客服',this.getStoreInfo,'error')
        }
      },
    },
    created () {
      if (this.allChecked && this.storeInfo.verify === 0) this.setVerifyStatue();
      //酒店和民宿类型时获取房间列表信息
      this.getStoreInfo({store_id: this.userLoginMessage.submit_store_id});
      // if (this.$GFUN.isInArray([3,5],this.storeInfo.type)) this.getRoomLists();
    },
    methods: {
      ...mapActions(['setStoreVerify', 'getStoreInfo','getRoomLists','updateInfo']),
      /*提交认证*/
      setVerifyStatue () {
        this._confirm('确认资料无误并提交认证么？', () => { 
          this.setStoreVerify({
            data: { verify: '2',},
            successFun: (res) => {
              if(this.userLoginMessage.status==2){
                this.$router.push({name:'regBasicClose'});
                return;
              }
              //更新门店信息
              this.getStoreInfo({store_id: this.userLoginMessage.submit_store_id});
              // 更新用户信息
              // this.updateInfo()
            }
          })
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .check-item {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 10px;
  }
</style>
